import React, {Component} from 'react';
import axios from 'axios';
import Breadcrumb from  '../../../components/Layout/Breadcrumb';
import ModalComponent from  '../../../components/ModalComponent';
import {FaCloud, FaSearch} from "react-icons/fa";
import {
    Button,
    Card,
    CardBody,
    DropdownItem,
    DropdownMenu,
    DropdownToggle, Input, InputGroup, InputGroupAddon,
    Table,
    UncontrolledButtonDropdown
} from 'reactstrap';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import PaginateComponent from "../../../components/PaginateComponent";
import ListVpsComponent from "../../../components/Admin/vps/ListVpsComponent";

class AdminListVpsExpirePage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            listService: [],
            perPage: 0,
            totalPage: 0,
            currentPage: 0,
            error: false,
            messageError: '',
            isNotification: '',
            textNotification: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            action: '',
            isBtnConfirm: true,
            contentModal: '',
            btnConfirmDisabled: false,
            isSpinner: false,
            actionKey: 0,
            alert: {
                error: false,
                message: ''
            },
            userId: 0,
            typeOrder: '',
            qtt: 30,
            search: '',
            status: 'expire',
            listStatus: {},
            btn_all: 'Chọn hành động'
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getListService();

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getListService = () => {
        this.setState({
            isLoading: true,
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let data = "?qtt=" + this.state.qtt + "&q=" + this.state.search + "&status=" + this.state.status;

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/vps/listVps' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listStatus: ref.data.listStatus,
                        listService: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                        loadPage: false,
                        isLoading: false,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu dịch vụ thất bại',
                })
            })
    }

    changeQtt = async (event) => {
        let value = event.target.value;
        await this.setState({
            qtt: value
        })
        await this.getListService();
    }

    changeStatus = async (event) => {
        let value = event.target.value;
        await this.setState({
            status: value
        })
        await this.getListService();
    }

    search = (event) => {
        // console.log(event.target.value)
        this.setState({
            search: event.target.value
        })
    }

    submitSearch = (event) => {
        if(event.key === 'Enter') {
            this.getListService();
        }
    }

    btnSearch = () => {
        this.getListService();
    }

    paginate = () => {
        if (this.state.totalPage > this.state.perPage) {
            return (
                <PaginateComponent
                    total={this.state.totalPage}
                    perPage={this.state.perPage}
                    currentPage={this.state.currentPage}
                    btnPaginate={ (page) => this.btnPaginate(page) }
                />
            );
        }
    }

    btnPaginate = (page) => {
        this.setState({
            isLoading: true
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        // console.log(dataAuth);
        let data = "?qtt=" + this.state.qtt + "&q=" + this.state.search + "&status=" + this.state.status + "&page=" + page;
        axios.get( process.env.REACT_APP_API_URL + '/api/admin/vps/listVps' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listService: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                        isLoading: false
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            isLoading: false
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isLoading: false
                });
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu khách hàng thất bại',
                })
            })
    }

    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <Alert color="success">
                    { this.state.textNotification }
                </Alert>
            );
        }
    }

    screentListService = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={12}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        } else {
            if ( this.state.listService.length ) {
                return (
                    this.state.listService.map( (service, key) => {
                        return (
                            <ListVpsComponent
                                key={key}
                                service={service}
                                actionKey={key}
                                showModal = { (actionKey, action) => this.showModal(actionKey, action) }
                                checkedService = { (actionKey) => this.checkedService(actionKey) }
                                checkedServiceShiftKey = { (actionKey, value) => this.checkedServiceShiftKey(actionKey, value) }
                            />
                        )
                    })
                )
            } else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="12">
                            Không có VPS trong dữ liệu!
                        </td>
                    </tr>
                )
            }
        }
    }

    checkedService  = (actionKey) => {
        let listService = this.state.listService;
        listService[actionKey].checked = !listService[actionKey].checked;
        this.setState({
            listService: listService,
            checkedStart: actionKey
        })
    }

    checkedServiceShiftKey = (actionKey, value) => {
        if ( this.state.checkedStart !== -1 ) {
            let listService = this.state.listService;
            let n = Math.abs( actionKey - this.state.checkedStart );
            let i = this.state.checkedStart;
            let k = actionKey;
            if ( actionKey < this.state.checkedStart ) {
                i = actionKey;
                k = this.state.checkedStart;
            }
            for (i; i <= n; i++) {
                listService[i].checked = value;
            }
            this.setState({
                listService: listService,
                checkedStart: k
            })
        } else {
            let listService = this.state.listService;
            listService[actionKey].checked = !listService[actionKey].checked;
            this.setState({
                listService: listService,
                checkedStart: actionKey
            })
        }
    }

    checkAll = (event) => {
        // console.log("da den")
        let value = event.target.checked;
        let listService = this.state.listService;
        listService.forEach( service => {
            service.checked = value;
        })
        this.setState({
            checkAll: value,
            listService: listService
        })
    }

    showModal = (key, action) => {
        let titleModal;
        let modalBody;
        if ( action === 'on' ) {
            titleModal = 'Bật VPS';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'off' ) {
            titleModal = 'Tắt VPS';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'restart' ) {
            titleModal = 'Khởi động lại VPS';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'rebuild' ) {
            titleModal = 'Yêu cầu cài đặt lại VPS';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'delete' ) {
            titleModal = 'Xóa VPS';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'expire' ) {
            titleModal = 'Yêu cầu gia hạn VPS';
            modalBody = this.modalBody(key, action);
        }
        this.setState({
            action: action,
            isModal: true,
            btnConfirmDisabled: false,
            contentModal: {
                modalBody: modalBody,
                title: titleModal
            },
            isBtnConfirm: true,
            isSpinner: false,
            actionKey: key
        })
    }

    modalBody = (key, action) => {
        if ( action === 'on' ) {
            return (
                <div className="text-center">
                    Bạn có muốn bật dịch vụ VPS <b className="text-danger">(ip: { this.state.listService[key].ip })</b> này không?
                </div>
            )
        }
        else if ( action === 'off' ) {
            return (
                <div className="text-center">
                    Bạn có muốn tắt dịch vụ VPS <b className="text-danger">(ip: { this.state.listService[key].ip })</b> này không?
                </div>
            )
        }
        else if ( action === 'restart' ) {
            return (
                <div className="text-center">
                    Bạn có muốn khởi động lại dịch vụ VPS <b className="text-danger">(ip: { this.state.listService[key].ip })</b> này không?
                </div>
            )
        }
        else if ( action === 'rebuild' ) {
            return (
                <div className="text-center">
                    Bạn có muốn cài đặt lại dịch vụ VPS <b className="text-danger">(ip: { this.state.listService[key].ip })</b> này không?
                </div>
            )
        }
        else if ( action === 'delete' ) {
            return (
                <div className="text-center">
                    Bạn có muốn xóa dịch vụ VPS <b className="text-danger">(ip: { this.state.listService[key].ip })</b> này không?
                </div>
            )
        }
        else if ( action === 'expire' ) {
            return (
                <div className="text-center">
                    Bạn có muốn gia hạn dịch vụ VPS <b className="text-danger">(ip: { this.state.listService[key].ip })</b> này không?
                </div>
            )
        }
        else if ( action === 'finish_expire' ) {
            return (
                <div className="text-center">
                    Yêu cầu gia hạn VPS thành công. Quý khách vui lòng bấm <a href="/" onClick={ () => this.redirectDetailOrder() }>vào đây </a>
                    để thanh toán hoàn thành quá trình gia hạn.
                </div>
            )
        }
        else if ( action === 'rebuild_chosse_vps' ) {
            return (
                <div className="text-center">
                    <label htmlFor="choose_vps">Chọn hệ điều hành</label>
                    <select className="form-control text-center" name="os" id="choose_vps" onChange={this.changeInput} defaultValue={key[0].id}>
                        {
                            key.map( (os, keyOs) => (
                                <option value={ os.id } key={keyOs}>{ os.os }</option>
                            ))
                        }
                    </select>
                </div>
            )
        }
        else if ( action === 'confirm_expire' ) {
            return (
                <div className="text-center">
                    <label htmlFor="choose_vps">Chọn thời gian gia hạn</label>
                    <select className="form-control text-center" name="billingCycle" id="billingCycle" onChange={this.changeInput} defaultValue={key[0].id}>
                        {
                            key.map( (billingCycle, keyBc) => (
                                <option value={ billingCycle.id } key={keyBc}>{ billingCycle.value }</option>
                            ))
                        }
                    </select>
                </div>
            )
        }
    }

    redirectDetailOrder = () => {
        let link = "/don-dat-hang/" + this.state.orderId + "/chi-tiet-don-dat-hang.html";
        this.hiddenModal();
        window.open(link, '_blank');
    }

    hiddenModal = () => {
        this.setState({
            action: '',
            isModal: false,
        })
    }

    confirmModal = () => {
        let listVps = [];
        if ( this.state.listService.length ) {
            this.state.listService.forEach( (service) => {
                if (service.checked) {
                    listVps.push(service.id);
                }
            })
        }

        this.setState({
            btnConfirmDisabled: true,
            isSpinner: true,
            isBtnConfirm: false,
            alert: {
                error: false,
                message: ''
            }
        })
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let form = {
            vpsId: this.state.listService[ this.state.actionKey ].id,
            action: this.state.action,
            billingCycle: this.state.billingCycle,
            os: this.state.os,
            listVps: listVps
        };

        axios.put( process.env.REACT_APP_API_URL + '/api/admin/vps/action', form,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    isSpinner: false,
                });
                if ( ref.data.error > 9000 ) {
                    this.props.logOut();
                }
                else if ( ref.data.error ) {
                    this.setState({
                        contentModal: {
                            modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                            title: this.state.contentModal.title
                        },
                    })
                }
                else {
                    if ( !ref.data.error ) {
                        window.scrollTo(0, 0);
                        this.getListService();
                    }
                    this.setState({
                        contentModal: {
                            modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                            title: this.state.contentModal.title
                        },
                    })
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isSpinner: false,
                    contentModal: {
                        title: this.state.contentModal.title,
                        modalBody: this.modalBodyConfirm(1, 'Thực hiện hành động không thành công')
                    },
                })
            })
    }

    modalBodyConfirm = (error, message) => {
        if ( error ) {
            return (
                <div className="text-center text-danger">
                    { message }
                </div>
            )
        } else {
            return (
                <div className="text-center text-success">
                    { message }
                </div>
            )
        }
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({
            [name]: value
        });
    }

    showModalAll = (action) => {
        // console.log(action)
        let slc = 0;
        if ( this.state.listService.length ) {
            this.state.listService.forEach( (service) => {
                if (service.checked) {
                    slc++;
                }
            })
        }
        if ( slc ) {
            let titleModal;
            let modalBody;
            if ( action === 'onAll' ) {
                titleModal = 'Bật VPS';
                modalBody = this.modalBodyAll(action, 0);
            }
            else if ( action === 'offAll' ) {
                titleModal = 'Tắt VPS';
                modalBody = this.modalBodyAll(action, 0);
            }
            else if ( action === 'restartAll' ) {
                titleModal = 'Khởi động lại VPS';
                modalBody = this.modalBodyAll(action, 0);
            }
            else if ( action === 'cancelAll' ) {
                titleModal = 'Xóa VPS';
                modalBody = this.modalBodyAll(action, 0);
            }
            this.setState({
                action: action,
                isModal: true,
                btnConfirmDisabled: false,
                contentModal: {
                    modalBody: modalBody,
                    title: titleModal
                },
                isBtnConfirm: true,
                isSpinner: false,
            })
        }
        else {
            alert("Vui lòng chọn 1 hoặc nhiều VPS");
        }
    }

    modalBodyAll = (action, key) => {
        if ( action === 'onAll' ) {
            return (
                <div className="text-center">
                    Bạn có muốn bật các dịch vụ VPS này không?
                </div>
            )
        }
        else if ( action === 'offAll' ) {
            return (
                <div className="text-center">
                    Bạn có muốn tắt các dịch vụ VPS này không?
                </div>
            )
        }
        else if ( action === 'restartAll' ) {
            return (
                <div className="text-center">
                    Bạn có muốn khởi động các dịch vụ VPS này không?
                </div>
            )
        }
        else if ( action === 'rebuildAll' ) {
            return (
                <div className="text-center">
                    Bạn có muốn cài đặt lại các dịch vụ VPS này không?
                </div>
            )
        }
        else if ( action === 'cancelAll' ) {
            return (
                <div className="text-center">
                    Bạn có muốn xóa các dịch vụ VPS này không?
                </div>
            )
        }
    }

    loadQttChecked = () => {
        let n = 0;
        if ( this.state.listService.length ) {
            this.state.listService.forEach( service => {
                if ( service.checked ) {
                    n++;
                }
            })
        }
        return (n);
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <>
                            <Breadcrumb title={"Quản lý dịch vụ VPS"} page={"VPS"} icon={<FaCloud className="breadcrumb-icon"/>} />
                            <Card>
                                <CardBody>
                                    <div className="dataTables_wrapper dt-bootstrap">
                                        {
                                            this.state.error ? (
                                                <div className="col-md-12">
                                                    <Alert color="danger">
                                                        {this.state.messageError}
                                                    </Alert>
                                                </div>
                                            ) : (
                                                <div className="list-group-email row">
                                                    <div className="col-md-4 mb-3 form-inline">
                                                        <select className="form-control form-control-sm mr-1" value={this.state.qtt} onChange={ this.changeQtt }>
                                                            <option value="10">10</option>
                                                            <option value="20">20</option>
                                                            <option value="30">30</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                            <option value="200">200</option>
                                                        </select>
                                                        <UncontrolledButtonDropdown>
                                                            <DropdownToggle caret size="sm">
                                                                { this.state.btn_all }
                                                            </DropdownToggle>
                                                            <DropdownMenu>
                                                                <DropdownItem onClick={ () => this.showModalAll('cancelAll') }>Xóa VPS</DropdownItem>
                                                            </DropdownMenu>
                                                        </UncontrolledButtonDropdown>
                                                    </div>
                                                    <div className="col-md-4 mb-3">
                                                    </div>
                                                    <div className="col-md-4">
                                                        <InputGroup>
                                                            <Input placeholder="Tìm kiếm VPS" onChange={ this.search } onKeyPress={ this.submitSearch } />
                                                            <InputGroupAddon addonType="prepend">
                                                                <Button onClick={ () => this.btnSearch() }> <FaSearch /> </Button>
                                                            </InputGroupAddon>
                                                        </InputGroup>
                                                    </div>
                                                    <div className="col-md-12 text-primary mb-3">
                                                        <b>
                                                            Đã chọn:
                                                            <span className="qtt-checkbox"> { this.loadQttChecked() }</span> / <span
                                                            className="total-item">{ this.state.listService.length }</span>
                                                        </b>
                                                    </div>
                                                    <div className="col-md-12">
                                                        {
                                                            this.checkNotification()
                                                        }
                                                    </div>
                                                    <div className="col col-md-12 table-responsive">
                                                        <Table className="table table-sm table-bordered table-hover rounded text-center">
                                                            <thead>
                                                            <tr>
                                                                <th width="3%"><input type="checkbox" defaultValue={false} onChange={ this.checkAll } /></th>
                                                                <th>Khách hàng</th>
                                                                <th>IP</th>
                                                                <th>Cấu hình</th>
                                                                <th>Ngày tạo</th>
                                                                <th>Ngày kết thúc</th>
                                                                <th>Tổng thời gian thuê</th>
                                                                <th>Chu kỳ thanh toán</th>
                                                                <th>Chi phí</th>
                                                                <th>Trạng thái</th>
                                                                <th>Hành động</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            { this.screentListService() }
                                                            </tbody>
                                                        </Table>
                                                        { this.paginate() }
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                </CardBody>
                            </Card>
                            <ModalComponent
                                isModal={ this.state.isModal }
                                content={this.state.contentModal}
                                isBtnConfirm={ this.state.isBtnConfirm }
                                isSpinner={ this.state.isSpinner }
                                btnConfirmDisabled={ this.state.btnConfirmDisabled }
                                hiddenModal={ () => this.hiddenModal() }
                                confirmModal={ () => this.confirmModal() }
                                alert={ this.state.alert }
                            />
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'AdminVpsExpire' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AdminListVpsExpirePage);